export const useDate = () => {
    const getToday = () => {
        const today = new Date()
        return today.toISOString().split('T')[0]
    }

    const getYesterday = () => {
        const today = new Date()
        const yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)

        return yesterday.toISOString().split('T')[0]
    }

    const getThisWeek = () => {
        const today = new Date()

        const dayOfWeek = today.getDay()
        const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek

        const monday = new Date(today)
        monday.setDate(today.getDate() + diffToMonday)

        const sunday = new Date(monday)
        sunday.setDate(monday.getDate() + 6)

        const formatDate = (date: any) => date.toISOString().split('T')[0]

        return { monday: formatDate(monday), sunday: formatDate(sunday) }
    }

    const getPreviousWeek = () => {
        const today = new Date()

        const dayOfWeek = today.getDay()
        const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek

        const currentMonday = new Date(today)
        currentMonday.setDate(today.getDate() + diffToMonday)

        const previousMonday = new Date(currentMonday)
        previousMonday.setDate(currentMonday.getDate() - 7)

        const previousSunday = new Date(previousMonday)
        previousSunday.setDate(previousMonday.getDate() + 6)

        const formatDate = (date: any) => date.toISOString().split('T')[0]

        return {
            previousMonday: formatDate(previousMonday),
            previousSunday: formatDate(previousSunday),
        }
    }

    const getNextWeek = () => {
        const today = new Date()

        const dayOfWeek = today.getDay()
        const diffToNextMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek

        const nextMonday = new Date(today)
        nextMonday.setDate(today.getDate() + diffToNextMonday)

        const nextSunday = new Date(nextMonday)
        nextSunday.setDate(nextMonday.getDate() + 6)

        const formatDate = (date: any) => date.toISOString().split('T')[0]

        return {
            nextMonday: formatDate(nextMonday),
            nextSunday: formatDate(nextSunday),
        }
    }

    const getThisMonth = () => {
        const today = new Date()

        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)

        const formatDate = (date: any) => {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        }

        return {
            firstDay: formatDate(firstDay),
            lastDay: formatDate(lastDay),
        }
    }

    return { getToday, getYesterday, getThisWeek, getPreviousWeek, getThisMonth, getNextWeek }
}
